export default __webpack_public_path__ + "static/media/logo_white_letter.ef63ca79.svg";